<template>
    <label class="inline-flex items-center cursor-pointer">
        <input type="checkbox" :value="value" v-model="proxyChecked"
               class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 cursor-pointer">
        <span class="ml-1">
            <slot></slot>
        </span>
    </label>
</template>

<script>
export default {
    emits: ["update:modelValue"],

    props: {
        modelValue: [Number, Boolean],
        value: [String, Number]
    },

    computed: {
        proxyChecked: {
            get() {
                return !!this.modelValue;
            },

            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
    },
}
</script>
